import { useContext } from 'react';
import { BranchSelectionContext } from '.';

export const useBranchSelection = () => {
	return useContext(BranchSelectionContext);
};
